import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

export const SectionHeading = ({ label, title, intro, testId }) => {
  const reduced = useReducedMotion();
  return (
    <motion.div
      initial={reduced ? {} : { opacity: 0, y: 20 }}
      whileInView={reduced ? {} : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
      className="max-w-2xl"
      data-testid={testId}
    >
      <span className="inline-block rounded-full border border-primary/50 bg-secondary px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-primary">
        {label}
      </span>
      <h2 className="font-display mt-5 text-3xl sm:text-4xl font-bold leading-snug text-foreground">{title}</h2>
      {intro && <p className="mt-4 text-base md:text-lg leading-relaxed text-muted-foreground">{intro}</p>}
    </motion.div>
  );
};
